<div class="d-flex flex-column content">
  <div class="p-2 align-self-center">
    <h3>Just a template</h3>
  </div>
</div>
